import { memo, type MouseEvent } from "react";

import { type useCartLine } from "@shopify/hydrogen-react";

import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { Text } from "@components/Text";
import { tw } from "classnames";

const styles = {
  giftWithPurchaseContainer: tw(
    "flex",
    "w-full",
    "gap-2",
    "items-center",
    "justify-between",
    "p-2",
    "mt-4",
    "bg-white",
    "rounded-md",
    "border",
    "border-solid",
    "border-divider"
  ),
  giftIcon: tw("w-5", "h-5", "mr-2"),
  giftTextWithIcon: tw("flex"),
};

type Props = {
  handleOpenGiftWithPurchaseDrawer: (e: MouseEvent<HTMLElement>) => void;
  handlePreloadProduct: (e: MouseEvent<HTMLElement>) => void;
  itemQuantity: number | undefined;
  merchandise: ReturnType<typeof useCartLine>["merchandise"];
  selectedGiftsWithPurchase: ReturnType<
    typeof useCartLine
  >["selectedGiftsWithPurchase"];
  unselectedGiftWithPurchaseQuantity: number;
};

const CartProductGiftUnassignedItemsViewBase = ({
  handleOpenGiftWithPurchaseDrawer,
  handlePreloadProduct,
  itemQuantity,
  merchandise,
  selectedGiftsWithPurchase,
  unselectedGiftWithPurchaseQuantity,
}: Props) => {
  return (
    <>
      {Array.from({
        length: unselectedGiftWithPurchaseQuantity,
      }).map((_, index) => (
        <div
          className={styles.giftWithPurchaseContainer}
          key={`${merchandise?.product?.id}-${index}`}
          onMouseEnter={handlePreloadProduct}
        >
          <div className={styles.giftTextWithIcon}>
            <Icon className={styles.giftIcon} name="gift" />
            <Text size="sm">
              {merchandise?.giftWithPurchase?.reference?.title?.value}
              {unselectedGiftWithPurchaseQuantity > 1
                ? ` (${
                    index + (selectedGiftsWithPurchase?.length ?? 0) + 1
                  }/${itemQuantity})`
                : ""}
            </Text>
          </div>
          <Button
            onClick={handleOpenGiftWithPurchaseDrawer}
            type="pill-outline"
          >
            Select
          </Button>
        </div>
      ))}
    </>
  );
};

export const CartProductGiftUnassignedItemsView = memo(
  CartProductGiftUnassignedItemsViewBase
);
